import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Select2OptionData } from 'ng-select2';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Observable, Subject, timer } from 'rxjs';
import { tap, map, take, takeUntil } from 'rxjs/operators';
import { AddUpdateTerminalInteractionViewModel } from '../../models/add-update-terminal-interaction-view-model';
import { AddUpdateTerminalViewModel } from '../../models/add-update-terminal-view-model';
import { ContactDetailsViewModel } from '../../models/contact-details-view-model';
import { CreateResult } from '../../models/create-result';
import { InteractionTypeEnum } from '../../models/interaction-type-enum';
import { MerchantSignUpViewModel } from '../../models/merchant-sign-up-view-model';
import { MerchantSignedUpViewModel } from '../../models/merchants-sign-up-view-model';
import { TaTermConfigViewModel } from '../../models/ta-term-config-view-model';
import { TerminalSignUpViewModel } from '../../models/terminal-signup-view-model';
import { TerminalContactsViewModel } from '../../models/terminal-contacts-view-model';
import { TerminalInteractionViewModel } from '../../models/terminal-interaction-view-model';
import { TerminalInteractionsViewModel } from '../../models/terminal-interactions-view-model';
import { TerminalParamViewModel } from '../../models/terminal-param-view-model';
import { TerminalViewModel } from '../../models/terminal-view-model';
import { AuthenticationService } from '../../services/authentication.service';
import { CardAcceptorConfigService } from '../../services/card-acceptor-config.service';
import { CommsProfileService } from '../../services/comms-profile.service';
import { PermissionEnum } from '../../services/guards/permissions';
import { MerchantService } from '../../services/merchant.service';
import { ParticipantService } from '../../services/participant.service';
import { ProductProfileService } from '../../services/product-profile.service';
import { TerminalCapabilityService } from '../../services/terminal-capability.service';
import { TerminalConfigService } from '../../services/terminal-config.service';
import { TerminalService } from '../../services/terminal.service';
import { UserDataStoreService } from '../../services/user-data-store.service';
import { DeviceMakeViewModel } from '../../models/device-make-view-model';
import { DeviceModelViewModel } from '../../models/device-model-view-model';
import { TmCardAcceptorConfigViewModel } from '../../models/tm-card-acceptor-model';
import { DecodedNameLocation } from '../../models/decoded-name-location -view-model';
import { ConfirmationDialogComponent } from '../../partials/confirmation-dialog/confirmation-dialog.component';
import { AddUpdateTerminalSignUpViewModel } from '../../models/add-update-terminal-sign-up-view-model';
import { TerminalSignUpNotesViewModel } from '../../models/terminal-sign-up-notes';

@Component({
  selector: 'app-terminals-configuration',
  templateUrl: './terminals-configuration.component.html',
  styleUrls: ['./terminals-configuration.component.scss']
})
export class TerminalsConfigurationComponent implements OnInit {

  public tmCardAcceptor: TmCardAcceptorConfigViewModel;
  public TerminalFormGroup: FormGroup;
  public termTypes: Select2OptionData[] = [];
  public productProfiles: Select2OptionData[] = [];
  public capabilityProfiles: Select2OptionData[] = [];
  public commsProfiles: Select2OptionData[] = [];
  public terminalConfigsSelect2: Select2OptionData[] = [];
  public terminalMakeList: DeviceMakeViewModel[];
  public terminalModelList: DeviceModelViewModel[];
  public client: boolean;
  public terminalSignUpNote: TerminalSignUpNotesViewModel;
  public terminalSignUpNotes: TerminalSignUpNotesViewModel[] = [];
  bankingWindowDetail: string;
  parameterDownloadWindowDetail: string;
  weekend: string;
  confirm = false;
  public submitted = false;
  raiseDanger: boolean;
  success: boolean;
  message: string;
  danger: string;
  manualPanEntry: boolean;
  public createResult: CreateResult;
  public select2options: any = {
    multiple: false,
    width: '100%',
    allowClear: true
  };
  private _destroyed$ = new Subject<any>();
  public id: string;
  public canAdd: boolean;
  public canEdit: boolean;
  public terminal: TerminalViewModel;
  public taTermCfg: TaTermConfigViewModel;
  public terminalInteractions: TerminalInteractionViewModel[];
  public terminalInteractionsDetails: TerminalInteractionsViewModel[];
  public bankingWindowUpdate: AddUpdateTerminalInteractionViewModel;
  public parameterDownloadWindowUpdate: AddUpdateTerminalInteractionViewModel;
  public terminalUpdate: AddUpdateTerminalViewModel;
  public contactlessTerminalParam: TerminalParamViewModel;
  public contactDetails: TerminalContactsViewModel;
  public terminalSignUp: TerminalSignUpViewModel[] = [];
  public merchantSignUp: MerchantSignedUpViewModel;
  enableButtonSave: boolean;
  public remainingCount$: Observable<number>;
  public remainingCount: number;
  public redirect = false;
  public merchantInfor: string;
  public allTerms: FormArray;
  public ticketOwner: boolean;
  get form() { return this.TerminalFormGroup.controls; }
  get terminals() { return this.form['terminals'] as FormArray }
  get allTerminals(): FormArray { return this.TerminalFormGroup.get('terminals') as FormArray; }

  constructor(
    private _terminalConfigService: TerminalConfigService,
    private _commsProfileService: CommsProfileService,
    private _productProfileService: ProductProfileService,
    private _terminalCapabilityService: TerminalCapabilityService,
    private _router: Router,
    private route: ActivatedRoute,
    private _userDataStore: UserDataStoreService,
    private _authenticationService: AuthenticationService,
    private _modalService: NgbModal,
    private _terminalService: TerminalService,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _toastService: ToastrService,
    private _formBuilder: FormBuilder,
    private _cardAcceptorConfigService: CardAcceptorConfigService,
    private _merchantService: MerchantService,
    private _http: HttpClient,
    private _participantService: ParticipantService,
    private _modal: NgbActiveModal,
    private cdr: ChangeDetectorRef) {

    route.params.pipe(takeUntil(this._destroyed$)).subscribe(async params => {

      this.canEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditTerminal], []);
      this.canAdd = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddTerminal], []);

      this.id = params.id;
      this.enableButtonSave = true;
      this.client = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddTerminalSignUpNotes], []);

    });
  }

  public ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }



  public async ngOnInit() {

    this._ngxUiLoaderService.start();
    debugger;
    this.enableButtonSave = true;
    this.ticketOwner = false;

    //initiate 
    this.TerminalFormGroup = this._formBuilder.group({
      merchantNumber: [{ value: '', disabled: true }, [Validators.required, Validators.minLength(15), Validators.maxLength(15)]],
      shopName: [{ value: '', disabled: true }],
      dispatch: [false],
      notesFC: [''],
      terminals: this._formBuilder.array([])
    });

    this.merchantSignUp = await this._merchantService.GetMerchantSignedUp(this.id);
    this.terminalSignUp = await this._terminalService.GetBulkTerminalSignedUpByMerchantNotInStatus(this.id, 'Dispatched');
    this.terminalMakeList = await this._terminalService.GetDeviceMakes();
    this.terminalModelList = await this._terminalService.GetDeviceModels();

    var terminal = this.terminalSignUp[0];
    if (terminal.deliveryMethod == "Courier") {
      this.confirm = true;
    }

    //assign
    this.TerminalFormGroup = this._formBuilder.group({
      merchantNumber: [{ value: this.merchantSignUp?.merchantNumber, disabled: true }, [Validators.required, Validators.minLength(15), Validators.maxLength(15)]],
      shopName: [{ value: this.merchantSignUp?.shopName, disabled: true }],
      dispatch: [false],
      notesFC: [''],
      terminals: this._formBuilder.array([])
    });

    if (terminal.inUseById != null && (terminal.inUseById == this._userDataStore.currentUserValue.id)) {
      this.enableButtonSave = true;
      this.ticketOwner = true;
    }

    if (this.terminalSignUp.every(x => x.status === "New")) {
      this.ticketOwner = true;
      this.terminalSignUp.forEach(async (item) => {
        item.status = "Terminal preparation";
        await this._terminalService.UpdateTerminalSignedUp(item, false);
      });

      this.createFormGroup(false);
    }
    else if (this.terminalSignUp.some(x => x.status == "Terminal preparation") && this.ticketOwner) {
        this.createFormGroup(false);
    }
    else if (this.terminalSignUp.every(x => x.status == "Configuration complete") && this.ticketOwner) {
      this.createFormGroup(false);
    }
    else {
      this.createFormGroup(true);
    }

    this._ngxUiLoaderService.stop();
  }

  private createFormGroup(disableFormControl: boolean = false) {
    this.terminalSignUp.forEach((value) => {
      this.allTerminals.push(
        new FormGroup({
          serialNumber: new FormControl({ value: value.serialNumber, disabled: disableFormControl }),
          simNumber: new FormControl({ value: value.simNumber, disabled: disableFormControl }),
          baseSerialNumber: new FormControl({ value: value.baseSerialNumber, disabled: disableFormControl }),
          terminalId: new FormControl({ value: value.terminalId, disabled: true }),
          terminalMake: new FormControl({ value: this.GetDeviceMake(value.make), disabled: true }),
          terminalModel: new FormControl({ value: this.GetDeviceModel(value.model), disabled: true }),
          retail: new FormControl({ value: value.retail, disabled: true }),
          admin: new FormControl({ value: value.admin, disabled: true })
        }));
    });
  }

  async save() {
    debugger;
    this.submitted = true;
    if (this.TerminalFormGroup.invalid) {
      this.raiseDanger = true;
      this.danger = "The form is invalid. Please ensure that all mandatory fields are filled with the required input.";
    }
    else {
      this.raiseDanger = false;

      this._ngxUiLoaderService.start();


      await this.configureTerminal();

      this.configureTerminal().then(async () => {

        this.createResult = await this._terminalService.UpdateTerminalsSignedUp(this.terminalSignUp, this.TerminalFormGroup.controls["dispatch"].value);

        if (this.createResult.success) {
          this._toastService.success(this.createResult.message, "Success");
          this.close();
        } 
        else {
          this.raiseDanger = true;
          this.danger = this.createResult.message;
          this._toastService.error(this.createResult.message, "error");
        }

        this._ngxUiLoaderService.stop();

      });




      /*this.configureTerminal();

      setTimeout(async () => {

        this.createResult = await this._terminalService.UpdateTerminalsSignedUp(this.terminalSignUp, this.TerminalFormGroup.controls["dispatch"].value);

        if (this.createResult.success) {
          this._toastService.success(this.createResult.message, "Success");
          this.enableButtonSave = false;
        }
        else {
          this.raiseDanger = true;
          this.danger = this.createResult.message;
          this._toastService.error(this.createResult.message, "error");
        }

        this._ngxUiLoaderService.stop();

      }, 2000);
      */

    }
  }

  async configureTerminal() {
    debugger;
    this.tmCardAcceptor = await this._merchantService.GetTmCardAcceptor(this.TerminalFormGroup.controls["merchantNumber"].value);
    var nameLocation = this.decodeNameLocation(this.tmCardAcceptor.name_location);

    var terminalSignUp = this.terminalSignUp;
    this.terminalSignUp = [];
    //setTimeout(() => {

    for (let i = 0; i <= this.allTerminals.length; i++) {

      if (this.allTerminals.value[i] != undefined) {

        this.terminalSignUp.push({
          terminalId: terminalSignUp[i].terminalId,
          serialNumber: this.allTerminals.value[i].serialNumber,
          merchantName: nameLocation.shopName,
          simNumber: this.allTerminals.value[i].simNumber,
          baseSerialNumber: this.allTerminals.value[i].baseSerialNumber,
          brand: terminalSignUp[i].brand,
          changedBy: terminalSignUp[i].changedBy,
          changedOn: terminalSignUp[i].changedOn,
          comments: terminalSignUp[i].comments,
          data: terminalSignUp[i].data,
          date: terminalSignUp[i].date,
          deliveryMethod: terminalSignUp[i].deliveryMethod,
          dispatch: terminalSignUp[i].dispatch,
          form: terminalSignUp[i].form,
          id: terminalSignUp[i].id,
          inUseBy: terminalSignUp[i].inUseBy,
          inUseById: terminalSignUp[i].inUseById,
          inUseDate: terminalSignUp[i].inUseDate,
          merchantNumber: terminalSignUp[i].merchantNumber,
          participantId: terminalSignUp[i].participantId,
          priority: terminalSignUp[i].priority,
          source: terminalSignUp[i].source,
          status: terminalSignUp[i].status,
          trackingId: terminalSignUp[i].trackingId,
          type: terminalSignUp[i].type,
          wayBill: terminalSignUp[i].wayBill,
          sameAsMerchantAddress: terminalSignUp[i].sameAsMerchantAddress,
          make: terminalSignUp[i].make,
          model: terminalSignUp[i].model,
          retail: terminalSignUp[i].retail,
          admin: terminalSignUp[i].admin,
          bulkOrder: terminalSignUp[i].bulkOrder,
          deviceOwnership: terminalSignUp[i].deviceOwnership
        });
      }
    }


    //}, 2000);



  }

  public decodeNameLocation(nameLocation: string): DecodedNameLocation {
    return {
      shopName: nameLocation.substring(0, 23).trim(),
      city: nameLocation.substring(23, 36).trim(),
      region: nameLocation.substring(36, 38).trim(),
      country: nameLocation.substring(38, 40).trim(),
    };
  }

  public async viewNotes() {

    this._ngxUiLoaderService.start();
    var notes = await this._terminalService.GetTerminalSignUpNoteByBulk(this.TerminalFormGroup.controls["merchantNumber"].value);

    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = false;
    dialogRef.componentInstance.acceptButtonText = "Close";
    dialogRef.componentInstance.title = "Notes";

    var str = [];
    notes.forEach((note) => {

      str.push("<b>User:</b> " + note.changedBy);
      str.push("<b>Date:</b> " + note.changedOn);
      str.push("<b>Note:</b> " + note.notes);
      str.push("======================================================");
    });

    if (str.length == 0) {
      str.push("NO COMMENTS AVAILABLE.");
    }
    dialogRef.componentInstance.listMessage = str;


    this._ngxUiLoaderService.stop();
  }

  async SaveNote() {

    this._ngxUiLoaderService.start();
    if ((this.TerminalFormGroup.controls['notesFC'].value) != '') {
      var date = new Date;

      this.terminalSignUp.forEach(item => {
        var date = new Date;
        this.terminalSignUpNote = {
          merchantNumber: this.TerminalFormGroup.controls['merchantNumber'].value,
          terminalId: item.terminalId,
          notes: this.TerminalFormGroup.controls['notesFC'].value,
          changedBy: '',
          changedOn: date,
          source: '',
          id: 0,
          userId: ''
        };

        this.terminalSignUpNotes.push(this.terminalSignUpNote);

      });

      if (this.terminalSignUpNotes.length > 0) {
        this.createResult = await this._terminalService.AddTerminalSignUpNote(this.terminalSignUpNotes);
        if (this.createResult.success) {
          this._toastService.success(this.createResult.message, "Success");
          this.TerminalFormGroup.controls['notesFC'].setValue('');
        }
        else {
          this._toastService.error(this.createResult.message, "Error");
        }
      }
    }
    else {
      this._toastService.error("Please enter a note!", "Error");
    }
    this._ngxUiLoaderService.stop();
  }

  public GetDeviceMake(id: string) {
    if (parseInt(id) >= 0) {
      const foundItem = this.terminalMakeList.find(item => item.id === parseInt(id));
      return foundItem.make;
    }
    return "";
  }

  public GetDeviceModel(id: any) {
    if (parseInt(id) >= 0) {
      const foundItem = this.terminalModelList.find(item => item.id === parseInt(id));
      return foundItem.model;
    }
    return "";
  }

  public close() {
    this._modal.close();
  }

}
